import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import DatabaseKeyPage from "./pages/DatabaseKeyPage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import GIPForm from "./pages/GIPForm";

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

function AppRoutes() {
  const location = useLocation();
  const [dbKey, setDbKey] = useState(sessionStorage.getItem("databaseKey"));
  const [isLoggedIn, setIsLoggedIn] = useState(!!sessionStorage.getItem("userName"));

  // 🔄 Reactively watch for changes in sessionStorage on route change
  useEffect(() => {
    setDbKey(sessionStorage.getItem("databaseKey"));
    setIsLoggedIn(!!sessionStorage.getItem("userName"));
  }, [location]);

  // Check if user is fully authenticated (has both dbKey and userName)
  const isFullyAuthenticated = dbKey && isLoggedIn;

  return (
    <Routes>
      {/* Step 1: Database Key - redirect to dashboard if fully authenticated */}
      <Route
        path="/"
        element={isFullyAuthenticated ? <Navigate to="/dashboard" replace /> : <DatabaseKeyPage />}
      />

      {/* Step 2: Login - redirect to dashboard if fully authenticated, or to db key if no dbKey */}
      <Route
        path="/login"
        element={
          isFullyAuthenticated ? <Navigate to="/dashboard" replace /> :
          dbKey ? <LoginPage /> : <Navigate to="/" replace />
        }
      />

      {/* Step 3: Dashboard (only if logged in) */}
      <Route
        path="/dashboard"
        element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" replace />}
      />

      {/* GIP Form (only if logged in) */}
      <Route
        path="/gipform"
        element={isLoggedIn ? <GIPForm /> : <Navigate to="/login" replace />}
      />

      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
